import { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import NotificationSettingsTable from './components/NotificationSettingsTable';
import AddNotificationSettingForm from './components/AddNotificationSettingForm';
import ListGrid from '../../../../common/components/ListGrid/ListGrid';
import TableWrapper from '../../../../common/components/TableWrapper/TableWrapper';
import ListActions from '../../../../common/components/ListActions';
import Title from '../../../../common/components/Title';
import Modal from '../../../../common/components/Modal';
import {hetch} from "../../../../utils/fetch.hooked";

function NotificationSettings({ permission }) {
  const history = useHistory();
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [page, setPage] = useState(query.get('pageNumber') ?? 1);
  const [count, setCount] = useState(1);
  const [rows, setRows] = useState(null);

  const handleAddModalClose = () => setAddModalOpen(false);
  const triggerRefetch = () => setRefetch(refetch => !refetch);

  useEffect(() => {
    history.push({
      search: `pageNumber=${page}`
    })
  }, [history, page]);

  useEffect(() => {
    const fetchData = () => {
      setIsFetching(true);
      hetch(`/api/notification_settings?pageNumber=${page}`)
        .then(res => res.json())
        .then(res => {
          setRows(res?.content ?? []);
          setCount(Math.ceil(res.total/res.pageSize));
        })
        .finally(() => {
          setIsFetching(false);
        });
    }

    fetchData();
  }, [page, refetch]);

  const handleChange = (event, value) => {
    setPage(value);
  };

  return (
    <>
      <ListGrid
        header={(
            <Title
              title="Настройки уведомлений"
              actions={(
                <ListActions
                  addTitle="Добавить настройку уведомлений"
                  refreshTitle="Обновить список настроек уведомлений"
                  onAddClick={() => setAddModalOpen(true)}
                  isRefreshing={isFetching}
                  permission={permission}
                  onRefreshClick={() => triggerRefetch(refetch => !refetch)}
                />
              )}
            />
        )}
        body={(
          <TableWrapper
            rows={rows}
            count={count}
            page={page}
            emptyAlertText="Список настроек уведомлений пуст"
            isFetching={isFetching}
            onChange={handleChange}
          >
            <NotificationSettingsTable permission={permission} rows={rows} triggerRefetch={triggerRefetch}/>
          </TableWrapper>
        )}
      />
      <Modal
        header="Добавление настройки уведомлений"
        open={addModalOpen}
        onClose={handleAddModalClose}
      >
        <AddNotificationSettingForm triggerRefetch={triggerRefetch} handleClose={handleAddModalClose}/>
      </Modal>
    </>
  );
}

export default NotificationSettings;
